import { create } from "@storybook/theming";

export default create({
  base: "light",
  brandTitle: "DA Design System -- docs",
  brandUrl: "/",
  brandImage: "/daDesignSystem.svg",
});
